import { createComponent } from 'react-fela'

import calculatePerBreakpoint from '../utils/calculatePerBreakpoint'

const Spacer = props => ({
  flexGrow: typeof props.flex === 'boolean' ? 1 : (typeof props.flex === 'number' ? props.flex : undefined),
  flex: typeof props.flex === 'string' ? props.flex : undefined,
  flexBasis: props.size,
  extend: calculatePerBreakpoint(props.sizes, value => ({
    flexBasis: value
  }))
})

export default createComponent(Spacer)



// WEBPACK FOOTER //
// ../components/Spacer.js